module.exports = __webpack_public_path__ + "static/media/Frame.8f23b10e.jpg";